// KC Redding portfolio data — updated from the Family Law (AL) and Immigration resumes.

export const IMAGES = {
  capitol: 'https://customer-assets-4nw71qhi.emergentagent.net/job_kc-portfolio/artifacts/eqoolqng_image-gen-3%286%29.png',
  courtroom: 'https://customer-assets-4nw71qhi.emergentagent.net/job_kc-portfolio/artifacts/664vsrq8_courtroom_portrait_under_1mb.jpg',
  office: 'https://customer-assets-4nw71qhi.emergentagent.net/job_kc-portfolio/artifacts/yizm439t_Office%20Team%20Reviewing%20Documents.png',
};

export const PROFILE = {
  name: {
    first: 'Kenneth',
    middle: 'Christopher',
    nickname: 'KC',
    last: 'Redding',
  },
  fullTitle: 'Kenneth Christopher KC Redding',
  tagline: 'The Architect of Advocacy',
  credentialLine: 'Immigration & Family Law \u00b7 Removal Defense',
  email: 'kenneth@KCRedding.com',
  phone: '(786) 766-8887',
  location: 'Atlanta, GA \u00b7 Montgomery, AL',
  website: 'KCRedding.com',
  linkedin: 'https://linkedin.com/in/kcredding',
  portraitUrl: IMAGES.capitol,
  specialties: [
    'Immigration Law',
    'Family Law',
    'Removal Defense',
    'Asylum',
    'Civil Rights',
    'ADA',
  ],
  languages: [
    { code: 'en', flag: '\ud83c\uddfa\ud83c\uddf8', label: 'English',    level: 'Fluent' },
    { code: 'es', flag: '\ud83c\uddea\ud83c\uddf8', label: 'Espa\u00f1ol',   level: 'Fluent' },
    { code: 'pt', flag: '\ud83c\udde7\ud83c\uddf7', label: 'Portugu\u00eas', level: 'Fluent' },
    { code: 'pap', flag: '\ud83c\udde8\ud83c\uddfc', label: 'Papiamento', level: 'Native' },
  ],
};

export const SOCIALS = [
  { id: 'instagram', label: 'Instagram', handle: '@CourtsidewithKC', url: 'https://www.instagram.com/CourtsidewithKC' },
  { id: 'youtube',   label: 'YouTube',   handle: '@CourtsidewithKC', url: 'https://www.youtube.com/@CourtsidewithKC' },
  { id: 'tiktok',    label: 'TikTok',    handle: '@CourtsidewithKC', url: 'https://www.tiktok.com/@CourtsidewithKC' },
];

export const RETAINR = {
  name: 'RetainR',
  url: 'https://retainr.com',
  role: 'Founder',
  tagline: 'Prepare your case before you retain a lawyer.',
  summary:
    'RetainR is a consumer legal-tech platform that helps individuals navigate family-law matters through guided legal intake, document preparation, filing support, and optional access to attorneys. It bridges the gap between self-representation and full-service legal representation by helping users prepare their case before involving a lawyer.',
  description:
    'Built for people who are representing themselves or are not yet ready to hire counsel, RetainR guides users through their legal problem in plain language, collects the facts their case requires, helps prepare forms and filing materials, and offers a clear path to escalate to an attorney when the matter becomes too complex. When a user is ready for representation, RetainR generates an attorney-ready case summary so a lawyer never has to start from scratch.',
  features: [
    { title: 'Guided Legal Intake', body: 'Plain-language questions that surface the facts a family court actually needs.' },
    { title: 'Document Preparation', body: 'Forms and filing materials assembled from the user\u2019s own answers.' },
    { title: 'Pro Se Filing Support', body: 'Step-by-step workflows for self-represented litigants navigating the courthouse.' },
    { title: 'Attorney Escalation', body: 'A clear off-ramp to licensed counsel the moment a matter becomes too complex.' },
    { title: 'Attorney-Ready Case Summary', body: 'A structured brief of the case so a lawyer can pick up the file without starting over.' },
  ],
  matters: [
    'Custody & Visitation',
    'Child Support',
    'Divorce',
    'Georgia Legitimation',
    'Travel Authorization',
    'Family-Court Filings',
  ],
};

export const RESUMES = [
  {
    id: 'immigration',
    label: 'Immigration Focus',
    url: 'https://customer-assets-4nw71qhi.emergentagent.net/job_kc-portfolio/artifacts/uhvb41uv_d0ha062j_ImmigrationNew.pdf',
    filename: 'KC_Redding_Immigration_Resume.pdf',
  },
  {
    id: 'family',
    label: 'Family Law Focus',
    url: 'https://customer-assets-4nw71qhi.emergentagent.net/job_kc-portfolio/artifacts/r863g6mf_KCReddingAL.pdf',
    filename: 'KC_Redding_FamilyLaw_Resume.pdf',
  },
];

export const BIO_PARAGRAPHS = [
  "Kenneth Christopher \u201cKC\u201d Redding practices at the intersection of immigration and family law, with a docket rooted in Immigration Court and the family courts of Alabama and Georgia. Trained at Faulkner University\u2019s Thomas Goode Jones School of Law, he has appeared in 24 matters before Immigration Court \u2014 master calendar, bond, and individual hearings \u2014 securing bond in 73% of bond hearings and asylum grants in four of seven applications, a rate nearly six times the Atlanta Immigration Court average.",
  "In the Family Court Division of Alabama\u2019s 15th Judicial Circuit, he has drafted more than 500 bench and proposed orders for the Hon. Calvin L. Williams across divorce, custody, child support, contempt, modification, and protection-from-abuse matters, and observed 100+ contested hearings and trials. Earlier work includes the Tuscaloosa County District Attorney\u2019s Office and legislative and policy roles in the Office of the Governor of North Carolina.",
  "Before the law, KC spent two decades in aviation \u2014 as a pilot, crew-recovery specialist, and contract manager for Delta Air Lines \u2014 an operational discipline he now brings to deadline-driven litigation. Fluent in English, Spanish, and Portuguese and a native Papiamento speaker, he counsels clients across borders and languages, and is the founder of RetainR, a legal-tech platform for family-law matters.",
];

export const STATS = [
  { label: 'Immigration Court',   value: '24 Appearances' },
  { label: 'Asylum Grant Rate',   value: '57% \u00b7 4 of 7 Granted' },
  { label: 'Family Court',        value: '500+ Orders Drafted' },
  { label: 'Languages',           value: 'EN \u00b7 ES \u00b7 PT \u00b7 PAP' },
];

// ---- LEGAL EXPERIENCE (from resume) ----
export const EXPERIENCE = [
  {
    id: 'gip',
    org: 'Global Immigration Pathways',
    role: 'Summer Associate',
    location: 'Atlanta, GA',
    dates: 'May \u2013 Aug. 2026',
    tag: 'Removal Defense & Federal Immigration Litigation',
    highlights: [
      'Appeared in 24 matters before Immigration Court \u2014 master calendar, bond, and individual hearings \u2014 securing bond in 73% of bond hearings.',
      'Managed 10 active removal-defense matters simultaneously, owning deadline-sensitive EOIR and USCIS filings, evidence organization, and hearing preparation from intake through disposition.',
      'Achieved asylum grants in 4 of 7 client applications \u2014 a 57% grant rate, nearly six times the Atlanta Immigration Court\u2019s ~9.9% average.',
      'Prepared Form I-589 asylum applications, client declarations, corroborating exhibits, briefs, motions, and habeas corpus petitions for detained clients.',
      'Conducted client and sponsor interviews in English, Spanish, and Portuguese; developed immigration histories, evidentiary records, and case theories.',
      'Researched INA provisions, BIA and circuit precedent, country conditions, and procedural issues in asylum, detention, humanitarian, family-based, and visa matters.',
    ],
  },
  {
    id: 'clerkship',
    org: 'Hon. Calvin L. Williams \u2014 15th Judicial Circuit, Family Court Division',
    role: 'Judicial Law Clerk',
    location: 'Montgomery, AL',
    dates: 'Jun. 2025 \u2013 Present',
    tag: 'Judicial Clerkship \u00b7 Domestic Relations',
    highlights: [
      'Drafted 500+ bench and proposed orders in divorce, child custody, child support, contempt, modification, and protection-from-abuse proceedings \u2014 including detailed factual findings of the kind that support SIJS predicate orders.',
      'Assisted in managing a high-volume domestic-relations docket; observed 100+ contested hearings and trials.',
      'Reviewed statutes, case law, pleadings, GAL reports, exhibits, and hearing records in high-conflict family litigation.',
    ],
  },
  {
    id: 'da',
    org: 'Tuscaloosa County District Attorney\u2019s Office',
    role: 'Summer Law Clerk',
    location: 'Tuscaloosa, AL',
    dates: 'May \u2013 Aug. 2025',
    tag: 'Criminal Prosecution',
    highlights: [
      'Conducted legal research and case-file review supporting hearing and trial preparation for an active criminal caseload.',
      'Drafted research memoranda and organized evidence and exhibits for assistant district attorneys.',
    ],
  },
  {
    id: 'gain',
    org: 'Georgia Asylum & Immigration Network (GAIN)',
    role: 'Immigration Court Observer / Reporter',
    location: 'Atlanta, GA',
    dates: '2024 \u2013 Present',
    tag: 'Advocacy',
    highlights: [
      'Document outcomes and due-process concerns at detained and non-detained master calendar and individual hearings for immigration advocates.',
      'Observe Immigration Court procedure, case progression, and recurring issues affecting asylum seekers and other noncitizens.',
    ],
  },
  {
    id: 'gov',
    org: 'Office of North Carolina Governor Roy Cooper',
    role: 'Legislative & Policy Intern',
    location: 'Raleigh, NC',
    dates: 'Sep. 2022 \u2013 Dec. 2023',
    tag: 'Policy',
    highlights: [
      'Researched immigration, mixed-status families, undocumented students, education, civil rights, and H-1B policy.',
      'Drafted legislative summaries, legal analyses, and briefing materials for senior staff.',
    ],
  },
  {
    id: 'mccrory',
    org: 'Office of the Governor of North Carolina \u2014 Chief of Staff Thomas Stith III',
    role: 'Special Assistant to the Chief of Staff',
    location: 'Raleigh, NC',
    dates: '2015 \u2013 2017',
    tag: 'Executive Office',
    highlights: [
      'Supported executive-office operations, constituent and stakeholder coordination, and time-sensitive administrative work in a high-accountability public-service environment.',
    ],
  },
  {
    id: 'delta',
    org: 'Delta Air Lines \u00b7 Earlier: JetBlue, Seaborne, Air Wisconsin / United Express, US Airways',
    role: 'Contract Manager \u00b7 Senior Pilot Scheduler \u00b7 Pilot',
    location: 'Atlanta, GA',
    dates: '1999 \u2013 Present',
    tag: 'Aviation & Operations',
    highlights: [
      'Managed time-sensitive contractual, regulatory, and operational matters within a complex global airline environment governed by federal regulations and strict deadlines.',
      'Earlier roles as First Officer (Air Wisconsin / United Express), Crew Recovery / FAR Compliance (JetBlue), and Spanish Desk Supervisor / Trainer (US Airways).',
    ],
  },
];

// ---- EDUCATION ----
export const EDUCATION = [
  {
    degree: 'Juris Doctor',
    school: 'Faulkner University, Thomas Goode Jones School of Law',
    location: 'Montgomery, AL',
    details: [
      'Phi Alpha Delta \u2014 Chief Justice',
      'BLSA Constance Baker Motley Mock Trial Team',
      'Coursework: Immigration Law \u00b7 Federal Courts \u00b7 Administrative Law \u00b7 Evidence \u00b7 Criminal Procedure \u00b7 Trial Advocacy \u00b7 Family Law \u00b7 Children and the Law \u00b7 Mediation & ADR',
    ],
  },
  {
    degree: 'B.A., Business Administration \u00b7 A.A., Computer Science',
    school: 'Thomas Edison State University',
    location: 'Trenton, NJ',
    details: [
      'President\u2019s List',
      'Alpha Sigma Lambda Honor Society \u00b7 Sigma Beta Delta International Honor Society',
    ],
  },
];

// ---- CERTIFICATIONS & TRAININGS ----
export const CERTIFICATIONS = [
  {
    year: '2026',
    title: 'H-1B Training Certificate',
    body: 'Corporate Immigration Compliance Institute (CICI) \u2014 petitions, RFE responses, Public Access File compliance',
  },
  {
    year: '2025',
    title: 'Certified Migration Advisor \u2014 Advanced Immigration Diplomado',
    body: 'IINTCAP, Dominican Republic',
  },
  {
    year: '2025',
    title: 'Pre-Appointment Child Attorney / Guardian ad Litem Training',
    body: 'Georgia Office of the Child Advocate',
  },
  {
    year: 'AILA',
    title: 'Federal District Court Litigation / Removal Defense Certificate',
    body: 'Additional training in asylum, withholding of removal, CAT protection, cancellation of removal, VAWA, naturalization, marriage-based adjustment, H-1B, PERM, consular processing, and EB-5',
  },
  {
    year: 'CLINIC',
    title: 'Immigration Legal-Services Training',
    body: 'Certificate coursework supporting client-centered immigration practice',
  },
];

// ---- SKILLS ----
export const SKILLS = {
  litigation: [
    'Removal Defense & EOIR Practice',
    'Asylum / Form I-589',
    'Master Calendar, Bond & Individual Hearings',
    'Detention & Habeas Corpus',
    'Cancellation & Withholding of Removal',
    'Motions to Reopen \u00b7 BIA Appeals',
    'SIJS \u00b7 U & T Visas \u00b7 TPS \u00b7 DACA',
    'Waivers (I-601 / I-601A) \u00b7 VAWA',
  ],
  research: [
    'Westlaw',
    'LexisNexis (Certified)',
    'PACER \u00b7 Bloomberg Law',
    'INA, BIA & Circuit Precedent',
    'Briefs, Motions & Memoranda',
    'Bench & Proposed Orders',
    'Clio \u00b7 Microsoft 365',
  ],
  clientAdvocacy: [
    'Client & Sponsor Interviews',
    'Declarations & Factual Development',
    'Evidence Collection',
    'Hearing Preparation',
    'Multilingual & Cross-Cultural Communication',
  ],
};

export const PRACTICE_AREAS = [
  {
    id: 'immigration',
    tier: 'Primary',
    title: 'Immigration Law',
    tagline: 'Family, Humanitarian & Employment-Based Relief',
    items: [
      'Family-Based Immigration \u2014 I-130 petitions, adjustment of status, consular processing',
      'Employment Visas \u2014 H-1B, L-1, O-1, TN, and PERM labor certification',
      'Removal Defense \u2014 Cancellation, \u00a7 212(c) waivers, bond hearings, motions to terminate',
      'Asylum & Humanitarian Relief \u2014 VAWA, TPS, U-Visa, T-Visa, withholding of removal',
      'Naturalization & Citizenship \u2014 N-400, derivative citizenship, N-600',
      'Green Card / Permanent Residency \u2014 EB-1, EB-2, EB-3 categories',
      'RFE Responses \u2014 Strategic replies to USCIS Requests for Evidence',
    ],
  },
  {
    id: 'family',
    tier: 'Primary',
    title: 'Family Law',
    tagline: 'Where Family Law & Immigration Intersect',
    items: [
      'Divorce \u2014 Contested, uncontested, and international dissolution',
      'Custody \u2014 Legal and physical custody, parenting plans, modifications',
      'Child Support \u2014 Establishment, enforcement, and modification',
      'Pre- and Postnuptial Agreements',
      'Hague Convention \u2014 International parental child abduction cases',
      'Adoption \u2014 Domestic, international, and step-parent adoption',
      'Guardianship \u2014 Minor and adult guardianship proceedings',
    ],
  },
  {
    id: 'employment',
    tier: 'Secondary',
    title: 'Employment Law',
    tagline: 'Workplace Rights & Statutory Protection',
    items: [
      'Title VII Discrimination \u2014 Race, color, religion, sex, national origin',
      'Wage & Hour / FLSA \u2014 Overtime, minimum wage, misclassification claims',
      'Wrongful Termination \u2014 At-will exceptions, public policy violations',
      'Harassment \u2014 Hostile work environment, quid pro quo',
      'ADA \u2014 Reasonable accommodation, disability discrimination',
      'FMLA \u2014 Leave interference and retaliation',
      'Contractor Misclassification \u2014 Independent contractor vs. employee analysis',
    ],
  },
  {
    id: 'civil-rights',
    tier: 'Focus',
    title: 'Civil Rights',
    tagline: 'Constitutional Defense & Federal Litigation',
    items: [
      'Fourth Amendment \u2014 Motions to suppress, unreasonable search and seizure',
      'ADA Title I & II \u2014 Employment and public services accommodation',
      'Equal Protection \u2014 Fourteenth Amendment challenges',
      '\u00a7 1983 Actions \u2014 Civil rights claims against state actors',
      'Federal Appeals \u2014 Appellate brief writing and oral argument preparation',
    ],
  },
];

export const WRITING_SAMPLES = [
  {
    id: 'motion-suppress',
    title: 'Motion to Suppress Evidence',
    category: 'Criminal Defense \u00b7 Fourth Amendment',
    year: '2024',
    featured: true,
    available: true,
    snippet: 'Argues for the suppression of evidence obtained in violation of the Fourth Amendment, with a detailed application of the exclusionary rule and fruit-of-the-poisonous-tree doctrine.',
    url: 'https://customer-assets.emergentagent.com/job_e44547ff-434f-48e4-9b4c-7fd036fe931d/artifacts/cofs76gj_Motion%20to%20supress.pdf',
    filename: 'Motion_to_Suppress_Evidence.pdf',
  },
  {
    id: 'memo-dog-bite',
    title: 'Predictive Memorandum',
    category: 'Georgia Dog Bite Liability & Punitive Damages',
    year: '2024',
    featured: true,
    available: true,
    snippet: 'Analyzes liability under Georgia\u2019s dog bite statute (O.C.G.A. \u00a7 51-2-7) and the threshold for punitive damages where an owner had prior knowledge of vicious propensities.',
    url: 'https://customer-assets.emergentagent.com/job_kc-portfolio/artifacts/vowba5dr_PredictiveMemo.pdf',
    filename: 'Predictive_Memo_Dog_Bite.pdf',
  },
  {
    id: 'appellee-brief',
    title: 'Brief for Appellee',
    category: 'ADA Title I \u00b7 9th Circuit \u00b7 Perry v. Adventure Awaits',
    year: '2025',
    featured: false,
    available: true,
    snippet: 'Argues that reassignment under the ADA is not a reasonable accommodation when it violates a merit-based transfer policy. Relies on U.S. Airways v. Barnett and circuit-level reasonableness analysis.',
    url: 'https://customer-assets.emergentagent.com/job_e44547ff-434f-48e4-9b4c-7fd036fe931d/artifacts/hhpwhg3g_KENNETH%20REDDING%20APPELLEE%20BRIEF-%20Feedback%20%281%29.pdf',
    filename: 'Appellee_Brief_Perry_v_Adventure_Awaits.pdf',
  },
  {
    id: 'rfe-response',
    title: 'RFE Response',
    category: 'Immigration \u00b7 USCIS Request for Evidence',
    year: '2025',
    featured: false,
    available: true,
    snippet: 'Strategic response to a USCIS Request for Evidence \u2014 addresses evidentiary deficiencies with targeted documentary support and a structured legal argument under 8 C.F.R. \u00a7 103.2(b).',
    url: 'https://customer-assets.emergentagent.com/job_kc-portfolio/artifacts/kx2dqphz_RFE.pdf',
    filename: 'RFE_Response_USCIS.pdf',
  },
  {
    id: 'marital-agreement',
    title: 'Marital Settlement Agreement',
    category: 'Family Law \u00b7 Divorce & Asset Division',
    year: '2026',
    featured: false,
    available: false,
    snippet: 'Comprehensive marital settlement agreement drafted for equitable asset division \u2014 forthcoming.',
  },
  {
    id: 'motion-terminate',
    title: 'Motion to Terminate Removal Proceedings',
    category: 'Immigration \u00b7 Removal Defense',
    year: '2026',
    featured: false,
    available: true,
    snippet: 'Motion to terminate removal proceedings on jurisdictional and procedural grounds \u2014 challenges the sufficiency of the Notice to Appear and argues termination under Pereira and Niz-Chavez.',
    url: 'https://customer-assets.emergentagent.com/job_kc-portfolio/artifacts/csdw12a1_MOTION%20TO%20TERMINATE%20REMOVAL.pdf',
    filename: 'Motion_to_Terminate_Removal_Proceedings.pdf',
  },
];

export const MEMBERSHIPS = [
  { name: 'AILA', full: 'American Immigration Lawyers Association \u2014 Georgia\u2013Alabama Chapter', type: 'Professional' },
  { name: 'GAIN', full: 'Georgia Asylum & Immigration Network \u2014 Court Observer / Reporter', type: 'Advocacy' },
  { name: 'Georgia Hispanic Bar Association', full: '', type: 'Professional' },
  { name: 'AFCC', full: 'Association of Family & Conciliation Courts', type: 'Professional' },
  { name: 'Phi Alpha Delta', full: 'Chief Justice', type: 'Academic' },
  { name: 'NDAA', full: 'National District Attorneys Association', type: 'Professional' },
  { name: 'BLSA', full: 'Constance Baker Motley Mock Trial Team', type: 'Academic' },
  { name: 'Sports & Entertainment Law Society', full: '', type: 'Academic' },
  { name: 'IJM Advocacy Group', full: 'International Justice Mission', type: 'Advocacy' },
  { name: 'Catholic Bar Association', full: '', type: 'Professional' },
  { name: 'ADLA', full: 'Alabama Defense Lawyers Association', type: 'Professional' },
  { name: 'Alabama Coalition for Immigrant Justice', full: '', type: 'Advocacy' },
];

export const PRO_BONO = [
  'Montgomery Volunteer Lawyers Program',
  'Atlanta Legal Aid',
  'National Immigrant Justice Center',
  'KIND \u2014 Kids in Need of Defense',
  'Catholic Social Services of Montgomery (Immigrant Services)',
];

export const CITATIONS = [
  '8 U.S.C. \u00a7 1101(a)(15)',
  'INA \u00a7 208',
  'U.S. Airways v. Barnett, 535 U.S. 391',
  '42 U.S.C. \u00a7 1983',
  'O.C.G.A. \u00a7 51-2-7',
  'Fed. R. App. P. 28',
  'Title VII, 42 U.S.C. \u00a7 2000e',
  'ADA \u00a7 12112(b)(5)(A)',
  'Matter of A-B-, 27 I&N Dec. 316',
  'Padilla v. Kentucky, 559 U.S. 356',
];
